import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import "swiper/css/effect-cards";
gsap.registerPlugin(ScrollTrigger);

class Membership {
	constructor() {
		this.init();
	}

	init() {
		this.initModules();
	}

	initModules() {
		// Init Modules here
		this.initQuoteAnimation();
	}

	initQuoteAnimation() {
		// Split text into words and characters
		const quote = document.querySelector("[js-quote]");

		// Split text initially
		// this.splitTextIntoLines(quote);

		// Use ResizeObserver to watch for changes in container size
		const resizeObserver = new ResizeObserver(
			this.debounce(() => {
				this.splitTextIntoLines(quote);
			}, 500)
		); // Debounce set to 200ms delay

		// Observe the text container for size changes
		resizeObserver.observe(quote);
	}

	splitTextIntoLines(container) {
		const words = container.textContent.trim().split(" ");

		container.innerHTML = ""; // Clear container before adding spans

		// Create an array of span elements, one for each word
		const spans = words.map((word) => {
			const span = document.createElement("span");
			span.textContent = word + " ";
			return span;
		});

		// Add the spans to the container without affecting DOM flow yet
		spans.forEach((span) => container.appendChild(span));

		let lastTop = null; // Track the last known top position
		let currentLine = []; // Collect words in the current line
		const lines = []; // Store the final lines

		spans.forEach((span, index) => {
			const rect = span.getBoundingClientRect(); // Get the position of each word

			if (lastTop === null) lastTop = rect.top; // Set the initial position

			if (rect.top !== lastTop) {
				// If top position has changed, a new line has started
				lines.push(currentLine); // Save the previous line
				currentLine = []; // Start a new line
				lastTop = rect.top;
			}

			currentLine.push(span); // Add the word span to the current line
		});

		// Push the last line
		lines.push(currentLine);

		// Rebuild the content with actual DOM elements
		container.innerHTML = "";
		lines.forEach((line) => {
			const lineWrapper = document.createElement("span");
			const lineInner = document.createElement("span");
			lineWrapper.classList.add("line");
			lineInner.classList.add("line__inner");
			line.forEach((wordSpan) => lineInner.appendChild(wordSpan)); // Append words to the line
			lineWrapper.appendChild(lineInner); // Add the lineInner to the LineWrapper
			container.appendChild(lineWrapper); // Add the line to the container
		});

		this.animateLines();
	}

	animateLines() {
		// Animate the lines
		gsap.from("[js-quote] .line .line__inner", {
			yPercent: 150,
			duration: 1,
			ease: "power3.out",
			stagger: 0.07,
			scrollTrigger: {
				trigger: "[js-quote]",
				start: "top +90%",
				// markers: true,
			},
		});
	}

	// Debounce function to limit the rate at which a function is executed
	debounce(func, delay) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), delay);
		};
	}
}

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	window.addEventListener("DOMContentLoaded", () => new Membership());
} else {
	// `DOMContentLoaded` has already fired
	new Membership();
}
